import { atom } from 'jotai';
import { PAGE } from '../constant/page';
import SnackbarProps from '../sharedComponents/snackbar/types';

export const pageAtom = atom(PAGE.LOGIN);
export const isBackdropOpenAtom = atom(false);
export const snackbarPropsAtom = atom<SnackbarProps>({
  isOpen: false,
  message: '',
  type: 'success',
});
